<template>
    <div id="vehicleVDP" :class="[$store.getters.getOrientation]">
        <vehicle-image-gallery/>
        <div id="vehicleTitleDiv">
            <div id="VDPTitleAndActionDiv">
                <div class="VDPTitleDiv">
                    <div id="yearAndMakeDiv">
                        <div class="carYear">
                            {{ vehicle.Year }}&nbsp;
                        </div>
                        <div class="carMake">
                            {{ vehicle.Make }}&nbsp;
                        </div>
                    </div>
                    <div id="modelAndTrimDiv">
                        <div>
                            {{ vehicle.Model }}&nbsp;
                        </div>
                        <div v-if="vehicleTrimExists()">
                            {{ vehicle.VehicleTrim }}
                        </div>
                    </div>
                    <div v-if="!$store.getters.isLoggedIn" class="carStockNumber">
                        {{ vehicle.StockNumber }}
                    </div>
                    <div v-else class="carStockNumber LoggedIn" @click="openAuctionPage(vehicle.AuctionPage)">
                        {{ vehicle.StockNumber }} 
                        <span class="vinDisplay">
                            {{ vehicle.VIN }}
                        </span>
                    </div>
                </div>

                <cta-button/>
                <crash-mark :crashedCar="vehicle" page="vdp" v-if="$store.getters.isLoggedIn"/>
            </div>
        </div>
        <div id="vehicleInformationDiv">
            <div class="vehicleDataPoint mobileCarPrice" @click="goToProposalLink">
                {{ priceTitle }}: {{ formatNumber(vehicle['PriceToShow'], 'PriceToShow') }}
            </div>
            <div class="vehicleDataPoint mobileCarMiles">
                Mileage: {{ formatNumber(vehicle['Miles'], 'Miles') }}
            </div>
            <div class="vehicleDataPoint mobileCarAcv" v-if="$store.getters.isLoggedIn">
                ACV includes PAC: {{ formatNumber(vehicle['ACV'], 'ACV') }}
            </div>
            <div class="vehicleDataPoint mobileCarBob" v-if="$store.getters.isLoggedIn">
                Back of Book includes PAC: 
                <span :class="[negativeBOB(vehicle['BOB']) ? 'negativeValue' : '']">
                    {{ formatNumber(vehicle['BOB'], 'BOB') }}
                </span>
            </div>
            <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.EngineSize)">
                Engine: {{ vehicle.EngineSize }}
            </div>
            <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.Transmission)">
                Transmission: {{ vehicle.Transmission }}
            </div>
            <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.Drive)">
                Drivetrain: {{ vehicle.Drive }}
            </div>
            <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.ExteriorColor)">
                Exterior Color: {{ vehicle.ExteriorColor }}
            </div>
            <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.InteriorColor)">
                Interior Color: {{ vehicle.InteriorColor }}
            </div>
            <div class="vehicleDataPoint">
                Options: {{ formatOptions() }}
            </div>
        </div>
        <autocheck-doc/>
        <div id="bottomButtonDiv">
            <cta-button/>
        </div>
    </div>
</template>


<script>
    import CallToActionButton from './CallToActionButtons.vue'
    import AutoCheckDoc from './Autocheck.vue';
    import VehicleImageGallery from './VehicleImageGallery.vue';
    import CrashMark from './CrashMark.vue';

    export default {
        computed: {
            vehicle() {
                return this.$store.getters.vehicleGallerySelected;
            },
            priceTitle() {
                return this.$store.getters.isLoggedIn ? "Price includes PAC" : "Price";
            },
            proposalLink() {
                return this.$store.getters.getAppUrlByName('mycar') + "/component/textProposal/" + this.vehicle['StockNumber'];
            }
        },
        components: {
            'cta-button': CallToActionButton,
            'autocheck-doc': AutoCheckDoc,
            'vehicle-image-gallery': VehicleImageGallery,
            'crash-mark': CrashMark
        },
        methods: {
            formatNumber: function (num, type) {
                var numFormated = "";
                
                if(num) {
                    if(type == 'PriceToShow' || type == 'ACV' || type == 'BOB') {
                        numFormated = "$";
                    } 
                    
                    numFormated += num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

                    if(type == 'BOB' && num < 0) {
                        numFormated = "(" + numFormated.replace('-', '') + ")";
                    }
                }
                else {
                    numFormated = 0;
                }
                
                return numFormated;
            },
            negativeBOB(num) {
                let negative = false;
                
                if (num && num < 0) {
                    negative = true;
                }
                
                return negative;
            },
            informationAvailable(infoValue) {
                let available = false;

                if(infoValue) {
                    if(!['N/A','Unspecified','None'].includes(infoValue)) {
                        available = true;
                    }
                }

                return available;
            },
            formatOptions() {
                let optionsList = ""

                if(this.vehicle.Moonroof && this.vehicle.Moonroof == 1) {
                    optionsList += (optionsList ? ", ": "") + "Moonroof";
                }

                if(this.vehicle.RearEntertainment) {
                    optionsList += (optionsList ? ", " : "") + 'Rear Entertainment';
                }

                if(this.vehicle.Nav && this.vehicle.Nav == 1) {
                    optionsList += (optionsList ? ", " : "") + "Navigation";
                }

                if(this.vehicle.Leather && this.vehicle.Leather == 1) {
                    optionsList += (optionsList ? ", " : "") + "Leather";
                }

                if(this.vehicle.bcamera && this.vehicle.bcamera == 1) {
                    optionsList += (optionsList ? ", " : "") + "Backup Camera";
                }

                if(this.vehicle.CabType && this.vehicle.CabType != "None") {
                    optionsList += (optionsList ? ", " : "") + this.vehicle.CabType;
                }

                if(this.vehicle.thirdrow && this.vehicle.thirdrow == 1) {
                    optionsList += (optionsList ? ", " : "") + "Third Row";
                }

                if(this.vehicle.Doors && this.vehicle.Doors != "N") {
                    optionsList += (optionsList ? ", " : "") + this.vehicle.Doors + " Door";
                }

                return optionsList;
            },
            openAuctionPage(auction_page) {
                this.$gtag.event('open', {'event_category': 'auction_page','event_label': 'mobile'});
                this.$store.dispatch('openAppInSeperateWindow', auction_page);
            },
            vehicleTrimExists() {
                return (this.vehicle.VehicleTrim && this.vehicle.VehicleTrim != 'None');
            },
            goToProposalLink() {
                console.log("GOTO PROPOSAL LINK");
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'text_proposal_from_vdp','event_label': eventLabel});
                this.$store.dispatch('openAppInSeperateWindow', this.proposalLink);
            }
        }
    }
</script>

<style>
    #vehicleVDP {
        height: calc(65 * var(--vh));
        width: calc(100 * var(--vw));
        z-index: 3;
        position: fixed;
        top: calc(30 * var(--vh));
        left: 0;
        background-color: white;
        color:#666;
        overflow: scroll;
    }

    #VDPTitleAndActionDiv {
        width: calc(100 * var(--vw));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .VDPTitleDiv {
        margin: calc(2 * var(--vh)) calc(2 * var(--vh));
        width: calc((100 * var(--vw)) - (4 * var(--vw)));
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #yearAndMakeDiv {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }

    #modelAndTrimDiv {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: black;
        flex-direction: column;
        font-size: 2em;
    }

    #vehicleInformationDiv {
        text-align: left;
        margin: calc(2 * var(--vh));
    }

    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }

    .mobileCarDetails {
        width: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(4 * var(--vh));
    }

    .vehicleDataPoint {
        margin-bottom: calc(1 * var(--vh));
    }

    #bottomButtonDiv {
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .carStockNumber.LoggedIn {
        color: var(--mccluskeyBlue);/*#0077C0;*/ /*#0079B6;*/
        cursor: pointer;
    }

    .inmobile .carStockNumber {
        font-size: calc(2.1 * var(--vh));
    }
    
    .vinDisplay {
        margin: 0 calc(2 * var(--vh));
    }

    .negativeValue {
        color: red;
    }
</style>